import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=267d505e&scoped=true"
import script from "./ProductGallery.vue?vue&type=script&lang=js"
export * from "./ProductGallery.vue?vue&type=script&lang=js"
import style0 from "./ProductGallery.vue?vue&type=style&index=0&id=267d505e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267d505e",
  null
  
)

export default component.exports